import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WalletSpinner from '../../components/wallet-spinner';
import REDIRECT_TIMEOUT from '../../lib/redirect-utils';

class PrequalChase extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  componentDidMount() {
    if (!this.props.suppressRedirect) {
      setTimeout(() => {
        this.form.current.submit();
      }, REDIRECT_TIMEOUT);
    }
  }

  render() {
    if (this.props.suppressRedirect) {
      return (
        <div className="redirect-holder">
          <WalletSpinner />
          <p>Redirect suppressed.</p>
        </div>
      );
    }

    return (
      <div className="redirect-holder">
        <WalletSpinner />
        <form
          ref={this.form}
          name="samlPostAssertion"
          action={this.props.product.chase.target_url}
          method="POST"
        >
          <input
            type="hidden"
            name="SAMLResponse"
            value={this.props.product.chase.assertion}
          />
        </form>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PrequalChase.propTypes = {
  product: PropTypes.shape({
    chase: PropTypes.shape({
      target_url: PropTypes.string.isRequired,
      assertion: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  suppressRedirect: PropTypes.bool,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PrequalChase.displayName = 'PrequalChase';

export default PrequalChase;
